<template>
  <div class="html-component" v-html="htmlData" />
</template>
<script>
import { logApiAccess, logForcedLogout } from '../utils/audit-logger'

export default {
  name: 'DynamicHtml',
  props: {
    url: {
      type: String,
      required: true
    },
    js: {
      type: String,
      default: () => ''
    },
    css: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      htmlData: null
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData () {
      const siteUri = window.location.pathname.slice(1).split("/")[0];
      const token = window.localStorage.getItem(`gg-${siteUri}-token`)
      let response
      try {
        response = await fetch(this.url, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        })
      } catch {
        logApiAccess('GET', this.url, 'failed', null)
        return
      }
      if (response.status === 401) {
        logApiAccess('GET', this.url, 'failed', 401)
        logForcedLogout('token_expired_401')
        window.localStorage.removeItem(`gg-${siteUri}-token`)
        if (window.localStorage.getItem('login_required') === 'true') {
          window.location.reload()
        }
        return
      }
      logApiAccess('GET', this.url, response.ok ? 'success' : 'failed', response.status)
      const res = await response.text()
      try {
        this.htmlData = JSON.parse(res)
      } catch(err) {
        this.htmlData = res
      }

      if (this.js) {
        if (document.head.querySelector(`script[src="${this.js}"]`)) {
          return
        }
        var scriptTag = document.createElement('script')
        scriptTag.type = 'text/javascript'
        scriptTag.src = this.js
        document.head.appendChild(scriptTag)
      }
      if(this.css) {
        if (document.head.querySelector(`link[href="${this.css}"]`)) {
          return
        }
        var link = document.createElement('link')
        link.rel = 'stylesheet'
        link.href = this.css
        document.head.appendChild(link)
      }
    }
  }
}
</script>